/**
 * Выбор ячейки по типу колонки (§5.2). Одна точка входа: строка не знает,
 * чем рисуется значение, а ячейка не знает про геометрию — её держит CellBox.
 */
import type { ColumnDef } from '../columns.js'
import type { CellProps } from './CellBox.js'
import { BoolCell } from './BoolCell.js'
import { CommentCell } from './CommentCell.js'
import { CommentsCell, NaCell } from './CountCell.js'
import { MultiselectCell, UserCell } from './CustomFieldCell.js'
import { DateCell } from './DateCell.js'
import { EnumCell } from './EnumCell.js'
import { GroupFoldCell } from './GroupFoldCell.js'
import { NumberCell } from './NumberCell.js'
import { PresenceCell } from './PresenceCell.js'
import { TextCell } from './TextCell.js'
import { TierCell } from './TierCell.js'
import { UrlCell } from './UrlCell.js'

export { CellBox, cellLayer } from './CellBox.js'
export type { CellActions, CellLayer, CellProps, CellState } from './CellBox.js'
export { NaCell }

export interface CellContentProps extends CellProps {
  /** Каталог колонок канала: нужен индикатору свёрнутой группы. */
  catalog: ColumnDef[]
}

export function CellContent(props: CellContentProps) {
  switch (props.column.role) {
    case 'enum': return <EnumCell {...props} />
    case 'tier': return <TierCell {...props} />
    case 'text': return <TextCell {...props} />
    case 'url': return <UrlCell {...props} />
    case 'bool': return <BoolCell {...props} />
    case 'number': return <NumberCell {...props} />
    case 'date': return <DateCell {...props} />
    case 'user': return <UserCell {...props} />
    case 'multiselect': return <MultiselectCell {...props} />
    case 'presence': return <PresenceCell {...props} />
    case 'groupFold': return <GroupFoldCell {...props} />
    case 'comments': return <CommentsCell {...props} />
    case 'comment': return <CommentCell {...props} />
    default: return null
  }
}
